<template>
  <div class="invite-page">
    <div class="invite-page__aside">
      <div class="invite-page__aside-content">
        <LoginBanner invite />
        <PreferencesBasicInfo v-if="resolved" :currentUser="invitePreview" invite />
      </div>
    </div>
    <div class="invite-page__content">
      <BaseLoadingBar v-if="pending" />
      <InviteError v-if="error" :error="error" />
      <Invite v-show="resolved" :invitePreview="invitePreview" :token="token" />
    </div>
  </div>
</template>

<script>
import BaseLoadingBar from '@/components/base/BaseLoadingBar';
import InviteError from '@/components/page-invite/InviteError';
import Invite from '@/components/page-invite/Invite';
import LoginBanner from '@/components/page-login/LoginBanner.vue';
import PreferencesBasicInfo from '@/components/page-admin-user-profile/PreferencesBasicInfo';
import { paths } from '@/util/paths';

import { localize } from '@/util/i18n/localize';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'PageInvite',
  components: {
    BaseLoadingBar,
    InviteError,
    LoginBanner,
    PreferencesBasicInfo,
    Invite,
  },
  data() {
    return {
      previewUser: {},
    };
  },
  props: {
    token: String,
  },
  computed: {
    ...mapGetters('validateInvite', ['pending', 'error', 'resolved', 'invitePreview']),
  },
  methods: {
    ...mapActions('validateInvite', ['validateInvite']),
  },
  beforeCreate() {
    if (!this.$route.params.token) {
      this.$router.push(paths.login);
      return;
    }
  },
  created() {
    this.validateInvite(this.token).then((invitePreview) => {
      if (invitePreview && invitePreview.locale) {
        localize(invitePreview.locale);
      }
    });
  },
};
</script>

<style lang="scss">
.invite-page {
  background-color: $color-white;
  display: flex;
  height: 100%;
  width: 100%;

  &__aside {
    display: flex;
    justify-content: center;
    height: var(--viewport-height);
    width: 33%;
    border-right: 1px solid $color-border;
    background: $color-slate-100;
  }

  &__aside-content {
    margin: auto;
    justify-content: center;
    padding: 25px;
  }

  &__content {
    align-items: center;
    display: flex;
    flex: auto;
    flex-direction: column;
    justify-content: center;
    width: 67%;
    padding: 64px;
    overflow-y: auto;
  }
}

@media screen and (max-width: 1080px) {
  .invite-page {
    display: block;
    position: absolute;
    overflow-y: auto;

    &__aside {
      width: 100%;
      height: 320px;
    }

    &__aside-content {
      min-width: 350px;
      max-width: 800px;
    }

    &__content {
      min-height: 50vh;
      width: 100%;
      padding: 32px;
      margin: auto;
    }
  }
}

@media screen and (max-width: 468px) {
  .invite-page {
    &__content {
      padding-bottom: 64px;
    }
  }
}
</style>
